/**
 * @typedef {{
 *  companyFoundersSidebarTitle?: string;
 *  companyDetailsSidebarTitle?: string;
 *  newsListingSidebarTitle?: string;
 *  eventListingUpcomingSidebarTitle?: string;
 *  eventListingPastSidebarTitle?: string;
 * }} SidebarTitlesObject
 */

/**
 * @type {SidebarTitlesObject}
 */
let SIDEBAR_TITLES = {};

/**
 * Set global site context
 * @param {SidebarTitlesObject} d
 */
export const setSidebarTitles = (d) => {
    SIDEBAR_TITLES = d;
};

/**
 * Get global site context
 * @return {SidebarTitlesObject}
 */
export const getSidebarTitles = () => {
    // new URL or something
    return SIDEBAR_TITLES;
};
